import { Ref, forwardRef } from 'react'

import * as S from './button.styles'

import { ButtonColorT, ButtonSizeT, ButtonVariantT, IButtonProps } from './button.types'
import { Typography, Loader, LoaderColorE, LoaderVariantE } from 'primsell-shared-layer/components'
import { ColorT, TypographyVariantsT } from 'primsell-shared-layer/components/atoms/typography/typography'

const typographyVariantConfig: Record<ButtonSizeT, TypographyVariantsT> = {
  xxs: 'button1',
  xs: 'button1',
  sm: 'button1',
  base: 'button1',
  md: 'button1',
  lg: 'button1',
  xl: 'button2',
}

const typographyColorConfig: Record<ButtonVariantT, Record<ButtonColorT, ColorT>> = {
  filled: {
    violet: 'white',
    dark: 'white',
    grey: 'dark',
    lightGrey: 'white',
  },
  outlined: {
    violet: 'violet',
    dark: 'dark',
    grey: 'darkGrey',
    lightGrey: 'darkGrey',
  },
}

const Button = forwardRef(
  (
    {
      color = 'violet',
      variant = 'filled',
      size = 'base',
      iconPosition,
      children,
      icon,
      className,
      isLoading,
      ...props
    }: IButtonProps,
    ref?: Ref<HTMLButtonElement>
  ) => {
    return (
      <S.Button
        className={className}
        size={size}
        color={color}
        variant={variant}
        {...props}
        ref={ref}
        disabled={isLoading || props.disabled}
      >
        <S.Inner>
          <S.PositionElementsContainer iconPosition={iconPosition}>
            {icon && <S.IconContainer>{icon}</S.IconContainer>}
            {children && (
              <Typography variant={typographyVariantConfig[size]} color={typographyColorConfig[variant][color]}>
                {children}
              </Typography>
            )}
          </S.PositionElementsContainer>
          {isLoading && <Loader color={LoaderColorE.WHITE} variant={LoaderVariantE.SECONDARY} />}
        </S.Inner>
      </S.Button>
    )
  }
)

Button.displayName = 'button'

export { Button }
